import { FC, useEffect, useRef } from 'react'

import styles from './RetailerSearch.module.scss'

type RetailerSearchProps = {
  map: google.maps.Map
  searchPlaceholder: string
}

const RetailerSearch: FC<RetailerSearchProps> = ({
  map,
  searchPlaceholder,
}) => {
  const input = useRef<HTMLInputElement>(null)
  useEffect(() => {
    if (map && input.current) {
      const searchBox = new google.maps.places.SearchBox(input.current)
      searchBox.addListener('places_changed', () => {
        handlePlacesChanged(searchBox, map)
      })

      map.addListener('bounds_changed', () => {
        searchBox.setBounds(map.getBounds() as google.maps.LatLngBounds)
      })
    }
  }, [map, input])

  return (
    <div className={styles.container}>
      <input
        ref={input}
        className={styles.searchInput}
        placeholder={searchPlaceholder}
      />
    </div>
  )
}
const handlePlacesChanged = (
  searchBox: google.maps.places.SearchBox,
  map: google.maps.Map
) => {
  const places = searchBox.getPlaces()
  if (places.length == 0) {
    return
  }

  // For each place, get the icon, name and location.
  const bounds = new google.maps.LatLngBounds()

  places.forEach((place) => {
    if (!place.geometry || !place.geometry.location) {
      return
    }
    // Create a marker for each place.
    if (place.geometry.viewport) {
      // Only geocodes have viewport.
      bounds.union(place.geometry.viewport)
    } else {
      bounds.extend(place.geometry.location)
    }
  })

  map.fitBounds(bounds)
}
export default RetailerSearch
